import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "@/locales/en.json";
import helpEn from "@/locales/help/en.json";
import helpPtBR from "@/locales/help/pt-BR.json";
import ptBR from "@/locales/pt-BR.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: { ...en, help: helpEn } },
      "pt-BR": { translation: { ...ptBR, help: helpPtBR } },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "pt-BR"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

/**
 * Keep <html lang> aligned with the active UI language. A mismatch (English lang
 * attribute + Portuguese content) makes mobile browsers auto-translate the page,
 * which mutates the DOM under React and can crash it (see domTranslationGuard).
 */
function syncDocumentLanguage(language: string): void {
  if (typeof document !== "undefined") {
    document.documentElement.lang = language;
  }
}

syncDocumentLanguage(i18n.resolvedLanguage ?? i18n.language);
i18n.on("languageChanged", syncDocumentLanguage);

export default i18n;
